import { Helmet } from "react-helmet-async";
import { CONTACT } from "@/data/site";

/**
 * Injects a schema.org LocalBusiness / EventPlanner JSON-LD block for a given city.
 * Boosts local SEO for queries like "agence événementielle {city}".
 */
export default function CityLocalBusinessJsonLd({ city }) {
  if (!city) return null;
  const slug = city.name.toLowerCase().replace(/[^a-z]/g, "");
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "EventPlanner"],
    "@id": `https://desir-events.com/villes/${slug}#business`,
    name: `Désir Events — Agence événementielle ${city.name}`,
    legalName: CONTACT.legalName,
    description: city.seoDesc,
    url: `https://desir-events.com/villes/${slug}`,
    logo: "https://desir-events.com/desir-events-wordmark.png",
    image: "https://desir-events.com/desir-events-wordmark.png",
    email: CONTACT.email,
    telephone: `+33${CONTACT.phoneMobile.replace(/\D/g, "").slice(1)}`,
    priceRange: "€€€",
    address: {
      "@type": "PostalAddress",
      streetAddress: "129 rue de Servient",
      addressLocality: "Lyon",
      postalCode: "69003",
      addressRegion: "Auvergne-Rhône-Alpes",
      addressCountry: "FR",
    },
    areaServed: {
      "@type": "City",
      name: city.name,
      containedInPlace: { "@type": "AdministrativeArea", name: city.region },
    },
    ...(city.coords && {
      geo: { "@type": "GeoCoordinates", latitude: city.coords.lat, longitude: city.coords.lng },
    }),
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      opens: "00:00",
      closes: "23:59",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: `Prestations événementielles à ${city.name}`,
      itemListElement: [
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Lancement de produit" } },
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Inauguration & ouverture de boutique" } },
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Soirée & gala d'entreprise" } },
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Séminaire & convention" } },
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Team building" } },
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Fête de Noël d'entreprise" } },
        { "@type": "Offer", itemOffered: { "@type": "Service", name: "Voyage incentive à l'étranger" } },
      ],
    },
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
